// Verbindungs-Protokoll.
//
// Der Abbruch passiert genau dann, wenn niemand hinschaut: Bildschirm aus,
// App gewechselt, kurzes Funkloch. Hinterher ist nicht mehr feststellbar, ob
// das Token abgelaufen war, das Spotify-Geraet verschwunden ist oder der
// Browser den Tab eingefroren hat. Deshalb wird jedes relevante Ereignis
// mitgeschrieben — und zwar in localStorage, damit es einen Reload und einen
// Neustart der App ueberlebt.

const KEY = "musicQuizDiag";
const MAX = 200;

function load() {
  try {
    const roh = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(roh) ? roh : [];
  } catch (e) {
    return [];
  }
}

let puffer = load();
let letzterSchreibvorgang = 0;
let ausstehend = null;

function sichern() {
  // Nicht bei jedem Eintrag schreiben — im Fehlerfall kommen sie in Schueben.
  const jetzt = Date.now();
  if (jetzt - letzterSchreibvorgang > 2000) {
    letzterSchreibvorgang = jetzt;
    try {
      localStorage.setItem(KEY, JSON.stringify(puffer));
    } catch (e) { /* Speicher voll — Protokoll ist nicht wichtig genug */ }
    return;
  }
  if (ausstehend) return;
  ausstehend = setTimeout(() => {
    ausstehend = null;
    letzterSchreibvorgang = Date.now();
    try {
      localStorage.setItem(KEY, JSON.stringify(puffer));
    } catch (e) { /* egal */ }
  }, 2000);
}

/**
 * @param {string} typ   kurzer Schluessel, z.B. "status", "spotify", "sicht"
 * @param {string} text  was passiert ist
 * @param {object} [daten] optionale Zusatzwerte (HTTP-Code, Geraeteanzahl, …)
 */
export function logEvent(typ, text, daten) {
  const eintrag = { t: Date.now(), typ, text };
  if (daten && Object.keys(daten).length) eintrag.d = daten;

  // Identische Wiederholungen zusammenfassen, sonst laeuft der Puffer bei
  // einem dauerhaften Fehler in Sekunden voll und die Vorgeschichte ist weg.
  const letzter = puffer[puffer.length - 1];
  if (
    letzter &&
    letzter.typ === typ &&
    letzter.text === text &&
    JSON.stringify(letzter.d) === JSON.stringify(eintrag.d)
  ) {
    letzter.n = (letzter.n || 1) + 1;
    letzter.t = eintrag.t;
  } else {
    puffer.push(eintrag);
    if (puffer.length > MAX) puffer = puffer.slice(-MAX);
  }
  sichern();
}

export function readLog() {
  return puffer;
}

export function clearLog() {
  puffer = [];
  try {
    localStorage.removeItem(KEY);
  } catch (e) { /* egal */ }
}

const zeit = (ms) =>
  new Date(ms).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

/** Ein Textblock zum Verschicken — Umgebung oben, Ereignisse darunter. */
export function formatLog(umgebung = {}) {
  const kopf = [
    `Musikquiz Verbindungs-Protokoll`,
    `erstellt: ${new Date().toLocaleString()}`,
    `Browser: ${navigator.userAgent}`,
    `als App installiert: ${window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
      ? "ja"
      : "nein"
    }`,
    `Wake Lock verfuegbar: ${"wakeLock" in navigator ? "ja" : "nein"}`,
    ...Object.entries(umgebung).map(([k, v]) => `${k}: ${v}`),
    "",
  ];

  const zeilen = puffer.map((e) => {
    const wiederholt = e.n > 1 ? ` (${e.n}x)` : "";
    const daten = e.d ? "  " + JSON.stringify(e.d) : "";
    return `${zeit(e.t)}  [${e.typ}] ${e.text}${wiederholt}${daten}`;
  });

  return kopf.concat(zeilen).join("\n");
}

export { zeit as formatZeit };
